export default function DriverBankAccount() {

  return (
      <p>حساب های بانکی راننده</p>
  );
};